import { useCallback, useState } from 'react';
import { useElementSize } from '@fiverr-private/hooks';

const COMPLIANCE_SECTION_SMALL_SCREEN_WIDTH = 600;

export const useResizableRef = () => {
    const [ref, setRef] = useState<HTMLDivElement | null>(null);
    const { width } = useElementSize(ref);

    const setRefCallback = useCallback((node: HTMLDivElement | null) => {
        setRef(node);
    }, []);

    const compact = width < COMPLIANCE_SECTION_SMALL_SCREEN_WIDTH;

    return { ref: setRefCallback, compact };
};
